import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
let PasswordNotificationDialog = class PasswordNotificationDialog extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "toggleDialog", void 0);
    _defineProperty(this, "userFirstName", void 0);
    _defineProperty(this, "passwordUrl", void 0);
    _defineProperty(this, "visible", false);
  }
  copyPasswordUrl() {
    navigator.clipboard.writeText(this.passwordUrl);
  }
  onDialogClose() {
    this.visible = false;
    this.$emit("dialogClose");
  }
};
__decorate([Prop({
  default: false
})], PasswordNotificationDialog.prototype, "toggleDialog", void 0);
__decorate([Prop({
  default: ''
})], PasswordNotificationDialog.prototype, "userFirstName", void 0);
__decorate([Prop({
  default: ''
})], PasswordNotificationDialog.prototype, "passwordUrl", void 0);
PasswordNotificationDialog = __decorate([Options({
  watch: {
    toggleDialog() {
      this.visible = this.toggleDialog;
    }
  }
})], PasswordNotificationDialog);
export default PasswordNotificationDialog;